module.exports = __webpack_public_path__ + "static/media/burgerWhite@2x.16b6e534.png";